/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateRequestStatusHistoryElementDtoGen,
  MrfiktivRepairEstimateRequestControllerAcceptParamsGen,
  MrfiktivRepairEstimateRequestControllerGetParamsGen,
  MrfiktivRepairEstimateRequestControllerRejectParamsGen,
  MrfiktivRepairEstimateViewModelGen,
  MrfiktivUpdateRepairEstimateResponseAcceptDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class RepairEstimateRequest<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerGet
   * @summary (SCT) Get an repairEstimate
   * @request GET:/partner/{partnerId}/repair-estimate/{repairEstimateId}/request
   * @secure
   * @response `200` `MrfiktivRepairEstimateViewModelGen` The found record
   * @response `400` `void` Bad Request.
   * @response `403` `void` Forbidden.
   * @response `404` `void` Report not found.
   */
  repairEstimateRequestControllerGet = (
    { partnerId, repairEstimateId, ...query }: MrfiktivRepairEstimateRequestControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, void>({
      path: `/partner/${partnerId}/repair-estimate/${repairEstimateId}/request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerAccept
   * @summary (sct) Accepts a repair estimate request
   * @request PATCH:/partner/{partnerId}/repair-estimate/{repairEstimateId}/request/accept
   * @secure
   * @response `201` `MrfiktivRepairEstimateViewModelGen` The updated repairEstimate
   */
  repairEstimateRequestControllerAccept = (
    { partnerId, repairEstimateId, ...query }: MrfiktivRepairEstimateRequestControllerAcceptParamsGen,
    data: MrfiktivUpdateRepairEstimateResponseAcceptDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate/${repairEstimateId}/request/accept`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerReject
   * @summary (sct) Updates an repairEstimate
   * @request PATCH:/partner/{partnerId}/repair-estimate/{repairEstimateId}/request/reject
   * @secure
   * @response `201` `MrfiktivRepairEstimateViewModelGen` The updated repairEstimate
   */
  repairEstimateRequestControllerReject = (
    { partnerId, repairEstimateId, ...query }: MrfiktivRepairEstimateRequestControllerRejectParamsGen,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate/${repairEstimateId}/request/reject`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
